module.exports = __webpack_public_path__ + "static/media/Geoparc_FR.2dae1393.mp4";